import { render, staticRenderFns } from "./ExplainStaff.vue?vue&type=template&id=1911df03&scoped=true&"
import script from "./ExplainStaff.vue?vue&type=script&lang=js&"
export * from "./ExplainStaff.vue?vue&type=script&lang=js&"
import style0 from "./ExplainStaff.vue?vue&type=style&index=0&id=1911df03&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1911df03",
  null
  
)

export default component.exports